import React from "react";
import { useLocation, Link, useParams } from "react-router-dom";
import { FaRegFolder } from "react-icons/fa";
import BreadcrumbsContainer from "./BreadcrumbContainer";
import { useFetchProjectQuery } from "../../api/project";
import { useFetchImageQuery } from "../../api/image";
import { FaRegImage } from "react-icons/fa6";

export default function Breadcrumbs() {
    const location = useLocation();
    const { projectId, imageId } = useParams(); // assuming the URL parameter is named 'projectId'
    const { data: project, isLoading, isError } = useFetchProjectQuery(projectId||'');
    const { data: image, isLoading: isImageLoading, isError: isImageError } = useFetchImageQuery(imageId||'');
    
    // If the data is loading or there's an error, you can return null or some placeholder content
    if (isLoading) return <BreadcrumbsContainer aria-label="breadcrumb"/>;
    if (isError || !project) return <BreadcrumbsContainer aria-label="breadcrumb"><p>Error</p></BreadcrumbsContainer>;

    const pathnames = location.pathname.split("/").filter(x => x);

    // Replace the project ID in the pathnames array with the project name
    const pathnamesWithProjectName = pathnames.map(path => 
        path === projectId ? project.name : path // assuming the project data has a 'name' field
    );

    // replace the image ID in the pathnames array with the image name
    const pathnamesWithImageName = pathnamesWithProjectName.map(path => 
        path === imageId ? image?.name : path // assuming the image data has a 'name' field
    );

    if(isImageLoading || isLoading) return <BreadcrumbsContainer aria-label="breadcrumb"/>;
    if(isError) return <BreadcrumbsContainer aria-label="breadcrumb"/>;

    return (
        <BreadcrumbsContainer aria-label="breadcrumb">
            <ul>
                <li>
                    <Link to="/">
                        <FaRegFolder className="mr-2" aria-hidden="true" />
                        Home
                    </Link>
                </li>
                {pathnamesWithImageName.map((name, index) => {
                    const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
                    const isLast = index === pathnames.length - 1;

                    // do not render if the name is images
                    if (name === 'images') return null;

                    const getIcon = () => {
                    if(name === project.name) return <FaRegFolder className="mr-2" aria-hidden="true" />;
                    if(name === image?.name) return <FaRegImage className="mr-2" aria-hidden="true" />;
                    return <FaRegFolder className="mr-2" aria-hidden="true" />
                    }

                    return isLast ? (
                        <li key={name} aria-current="page" className="capitalize">
                            {getIcon()}
                            {name}
                        </li>
                    ) : (
                        <li key={name} className="capitalize">
                            <Link to={routeTo}>
                                    {getIcon()}
                                    {name}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </BreadcrumbsContainer>
    );
}
